import {
  PartFileViewerPageData,
  PartFileStandaloneViewerData,
} from '@frontend/api';

import {
  getFileExtension,
  isFileConvertible,
  isFileImg,
  isFilePDF,
  isFileVideo,
} from 'utils/helpers';

export const getViewerDisplayParameters = (
  partFile: PartFileViewerPageData | PartFileStandaloneViewerData,
) => {
  const { isManual, standardizedUrl, filename, hasGeometry } = partFile;
  const fileExt = getFileExtension(filename ?? '');
  const fileParams = {
    isDisplayableFile: isFileConvertible(fileExt) && !!standardizedUrl,
    isImg: isFileImg(fileExt),
    isPdf: isFilePDF(fileExt),
    isVideo: isFileVideo(fileExt),
  };
  return {
    ...fileParams,
    shouldShowCAD: hasGeometry,
    shouldShowPdf:
      (fileParams.isDisplayableFile || fileParams.isPdf) && !hasGeometry,
    shouldShowNoFileToDisplayScreen: isManual,
  };
};
